module.exports = __webpack_public_path__ + "media/images/logos/logo-map-pin-b6aa4e7ec61effd63be2389fcc0d38b3.png";